import { DSHeading, DSInput, DSRadioGroup, DSSelect } from '@stihl-design-system/components';
import { useTranslation } from 'next-i18next';
import { Controller } from 'react-hook-form';

import { AnswerFormat, RaffleParticipationQuestion } from '@phoenix/team-m/my-tool-shed/frontend/domain/model/benefits.model';

export const RaffleQuestions = ({ questions }: { questions: RaffleParticipationQuestion[] }) => {
  const { t } = useTranslation();

  const mapToRadioGroupOptions = (item: RaffleParticipationQuestion) =>
    item.options
      ? item.options
          .filter((opt): opt is NonNullable<typeof opt> => opt !== null)
          .map((opt) => ({
            label: String(opt.label),
            value: String(opt.value),
          }))
      : [
          { label: t('shared:shared_confirmation_yes'), value: '1' },
          { label: t('shared:shared_confirmation_no'), value: '0' },
        ];

  const renderField = ({ raffleQuestion, field, fieldState }) => {
    switch (raffleQuestion?.type) {
      case AnswerFormat.Boolean:
        return (
          <DSRadioGroup
            {...field}
            id={raffleQuestion.id}
            legend={raffleQuestion.question ?? ''}
            options={mapToRadioGroupOptions(raffleQuestion)}
            defaultValue={raffleQuestion.default}
            systemFeedback={fieldState.error?.message}
            invalid={fieldState.invalid}
          />
        );
      case AnswerFormat.SingleSelect:
        return (
          <DSSelect
            {...field}
            id={raffleQuestion.id}
            label={raffleQuestion.question}
            options={
              raffleQuestion.options?.map(({ label, value }) => ({
                key: value,
                label,
                value,
              })) ?? []
            }
            placeholder={t('shared:shared_supportForm_topic_dropdown_pleaseSelect')}
            invalid={fieldState.invalid}
            systemFeedback={fieldState.error?.message}
          />
        );
      default:
        return (
          <DSInput
            {...field}
            id={raffleQuestion.id}
            name={`question_${raffleQuestion.id}`}
            label={raffleQuestion.question}
            systemFeedback={fieldState.error?.message}
            invalid={fieldState.invalid}
            value={field.value ?? ''}
          />
        );
    }
  };

  return (
    <div id="questions" className="flex-1 space-y-5">
      <DSHeading tag="h3" size="small" className="text-wrap">
        {t('toolShed_myEquipment_raffle_answerQuestion', { count: questions.length })}
      </DSHeading>
      {questions.map((raffleQuestion) => (
        <Controller
          key={raffleQuestion.id}
          name={`question_${raffleQuestion.id}`}
          render={({ field, fieldState }) => renderField({ raffleQuestion, field, fieldState })}
        />
      ))}
    </div>
  );
};
